import { Children, forwardRef } from 'react';
import cn from 'classnames';
import styles from "./ServicesListStructure.module.scss";
import { AddServicesButton } from "../AddServicesButton/AddServicesButton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ServicesListStructure = /*#__PURE__*/forwardRef(function ServicesListStructure(props, ref) {
  const {
    children,
    addServicesTestid,
    emptyState,
    centerVertically,
    isReadOnly,
    agreementData,
    onClickAddServices,
    onServicesAdded
  } = props;
  return /*#__PURE__*/_jsxs("section", {
    className: cn(styles.root, {
      [styles.centerVertically]: centerVertically
    }),
    ref: ref,
    children: [children, Children.count(children) === 0 && emptyState ? emptyState : !isReadOnly && /*#__PURE__*/_jsx("div", {
      className: styles.addServiceBtn,
      children: /*#__PURE__*/_jsx(AddServicesButton, {
        agreementData: agreementData,
        testId: addServicesTestid,
        onClick: onClickAddServices,
        onServicesAdded: onServicesAdded
      })
    })]
  });
});